"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextEditor = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const dompurify_1 = require("dompurify");
const draft_js_1 = require("draft-js");
const react_draft_wysiwyg_1 = require("react-draft-wysiwyg");
const draftjs_to_html_1 = (0, tslib_1.__importDefault)(require("draftjs-to-html"));
const html_to_draftjs_1 = (0, tslib_1.__importDefault)(require("html-to-draftjs"));
const presets = (0, tslib_1.__importStar)(require("./toolbar-presets"));
const lib_1 = require("../../lib");
class RichTextEditor extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.handleChange = (editorState) => {
            this.setState({ editorState }, () => {
                this.props.onChange(this.getHtml());
            });
        };
        this.handleFocus = (e) => {
            this.setState((prev) => (Object.assign(Object.assign({}, prev), { focus: true })));
        };
        this.handleBlur = (e) => {
            this.setState((prev) => (Object.assign(Object.assign({}, prev), { focus: false })));
        };
        this.getContent = (value) => draft_js_1.EditorState.createWithContent(draft_js_1.ContentState.createFromBlockArray((0, html_to_draftjs_1.default)((0, dompurify_1.sanitize)(value))));
        this.getHtml = () => this.state.editorState.getCurrentContent().hasText()
            ? (0, draftjs_to_html_1.default)((0, draft_js_1.convertToRaw)(this.state.editorState.getCurrentContent()))
            : '';
        this.state = {
            focus: false,
            editorState: this.props.value
                ? this.getContent(this.props.value)
                : draft_js_1.EditorState.createEmpty(),
        };
    }
    render() {
        const { focus, editorState } = this.state;
        let toolbar;
        if (this.props.toolbar === 'email')
            toolbar = presets.emailOptions;
        else if (this.props.toolbar === 'saved-details')
            toolbar = presets.savedDetailsOptions;
        else if (this.props.toolbar === 'list')
            toolbar = presets.listOptions;
        else
            toolbar = presets.defaultOptions;
        return ((0, jsx_runtime_1.jsx)(react_draft_wysiwyg_1.Editor, { placeholder: this.props.placeholder || 'Message (optional)', wrapperClassName: (0, lib_1.classnames)((0, lib_1.bem)('rich-text-editor__wrapper', (0, lib_1.use)(focus, '--active')), this.props.className), editorClassName: (0, lib_1.classnames)((0, lib_1.bem)('rich-text-editor__editor', (0, lib_1.use)(focus, '--active'))), toolbarClassName: (0, lib_1.classnames)((0, lib_1.bem)('rich-text-editor__toolbar', (0, lib_1.use)(focus, '--active'))), toolbarOnFocus: true, stripPastedStyles: true, editorState: editorState, onFocus: this.handleFocus, onBlur: this.handleBlur, onEditorStateChange: (e) => this.handleChange(e), toolbar: toolbar }, void 0));
    }
}
exports.RichTextEditor = RichTextEditor;
exports.default = RichTextEditor;
//# sourceMappingURL=RichTextEditor.js.map